import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest, select } from "redux-saga/effects"
import { HrCodeCategories } from "app/models/hrCode"
import { getSorting } from "app/redux/hrLeaveEntitlementsTable/hrLeaveEntitlementsTable.selectors"
import * as notificationActions from "../notifications/notifications.actions"
import * as actions from "./hrLeaveEntitlements.actions"
import * as hrLeaveEntitlementsTableActions from "../hrLeaveEntitlementsTable/hrLeaveEntitlementsTable.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getHrLeaveEntitlemtentFlow(action: actions.GetHrLeaveEntitlementsAction): SagaIterator {
  try {
    const { payload } = action
    const response = yield call(api.getHrLeaveEntitlements, payload)
    yield put(actions.getHrLeaveEntitlementsSuccess(response?.data))
    if (payload.sort) yield put(hrLeaveEntitlementsTableActions.changeSorting(payload.sort))
  } catch (e) {
    yield put(actions.getHrLeaveEntitlementsFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postHrLeaveEntitlementFlow(action: actions.PostHrLeaveEntitlementsAction): SagaIterator {
  try {
    const { hrLeaveEntitlement, year } = action.payload
    const sort = yield select(getSorting)
    const response = yield call(api.postHrLeaveEntitlements, hrLeaveEntitlement)
    yield put(actions.postHrLeaveEntitlementSuccess(response?.data))
    yield put(
      actions.getHrLeaveEntitlements({
        employee_id: hrLeaveEntitlement.employee_id,
        hr_code_categories: [HrCodeCategories.Leave],
        year,
        sort,
      }),
    )
    yield put(
      notificationActions.show({
        id: "postRequest",
        message: "confirmationdialog.hr_leave_entitlement.create.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.postHrLeaveEntitlementFail(e))
    yield call(handleError, { error: e })
  }
}

export function* patchHrLeaveEntitlementFlow(action: actions.PatchHrLeaveEntitlementsAction): SagaIterator {
  try {
    const {
      hrLeaveEntitlement: { employee_id, ...rest },
      year,
      id,
    } = action.payload
    const response = yield call(api.patchHrLeaveEntitlements, rest, id)
    yield put(actions.patchHrLeaveEntitlementSuccess(response?.data))
    const sort = yield select(getSorting)
    yield put(
      actions.getHrLeaveEntitlements({
        employee_id,
        hr_code_categories: [HrCodeCategories.Leave],
        year,
        sort,
      }),
    )
    yield put(
      notificationActions.show({
        id: "patchRequest",
        message: "confirmationdialog.hr_leave_entitlement.update.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.patchHrLeaveEntitlementFail(e))
    yield call(handleError, { error: e })
  }
}

export function* deleteHrLEaveEntitlementFlow(action: actions.DeleteHrLeaveEntitlementsAction): SagaIterator {
  try {
    const { hrLeaveEntitlementId, employee_id, year } = action.payload
    const response = yield call(api.deleteHrLeaveEntitlements, hrLeaveEntitlementId)
    const sort = yield select(getSorting)
    yield put(actions.deleteHrLeaveEntitlementSuccess(response?.data))
    yield put(
      actions.getHrLeaveEntitlements({
        employee_id,
        hr_code_categories: [HrCodeCategories.Leave],
        year,
        sort,
      }),
    )
    yield put(
      notificationActions.show({
        id: "postRequest",
        message: "confirmationdialog.hr_leave_entitlement.delete.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.deleteHrLeaveEntitlementFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* hrLeaveEntitlementsSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getHrLeaveEntitlemtentFlow)
  yield takeLatest(actions.Types.POST, postHrLeaveEntitlementFlow)
  yield takeLatest(actions.Types.PATCH, patchHrLeaveEntitlementFlow)
  yield takeLatest(actions.Types.DELETE, deleteHrLEaveEntitlementFlow)
}
